(() => {
  const SELECTOR = '[data-strykr-ride-short]';
  const pad = (value) => String(value).padStart(2, '0');

  function formatMoney(cents, currency) {
    const amount = Number(cents || 0) / 100;
    try {
      return amount.toLocaleString('de-DE', { style: 'currency', currency: currency || 'EUR' });
    } catch (error) {
      return amount.toFixed(2).replace('.', ',') + ' €';
    }
  }

  function workingDeliveryDate() {
    const days = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];
    const months = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];
    const date = new Date();
    date.setDate(date.getDate() + 3);
    while ([0, 6].includes(date.getDay())) date.setDate(date.getDate() + 1);
    return `am ${days[date.getDay()]}, ${date.getDate()}. ${months[date.getMonth()]}`;
  }

  function isSellable(variant) {
    if (!variant) return false;
    if (String(variant.sku || '').startsWith('STR-RDS-01')) return true;
    return variant.available !== false || variant.inventory_policy === 'continue';
  }

  function initRideShort(root) {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const variantsEl = root.querySelector('[data-ride-variants-json]');
    const variants = variantsEl ? JSON.parse(variantsEl.textContent || '[]') : [];
    const optionButtons = [...root.querySelectorAll('[data-ride-option-position]')];
    const form = root.querySelector('[data-ride-product-form]');
    const idInput = form ? form.querySelector('input[name="id"]') : null;
    const cta = root.querySelector('[data-ride-submit]');
    const stickyCta = root.querySelector('[data-ride-sticky-submit]');
    const status = root.querySelector('[data-ride-form-status]');
    const priceNow = root.querySelector('[data-ride-price-now]');
    const priceOld = root.querySelector('[data-ride-price-old]');
    const saveTag = root.querySelector('[data-ride-save-tag]');
    const sku = root.querySelector('[data-ride-sku]');
    const padName = root.querySelector('[data-ride-pad-name]');
    const sizeName = root.querySelector('[data-ride-size-name]');
    const currency = root.dataset.currency || 'EUR';

    const selectedOptions = (root.dataset.selectedOptions || '').split('||').filter(Boolean);
    if (!selectedOptions.length && variants[0] && Array.isArray(variants[0].options)) {
      variants[0].options.forEach((value) => selectedOptions.push(value));
    }

    function currentVariant() {
      return variants.find((variant) => {
        return variant.options.every((value, index) => String(value) === String(selectedOptions[index]));
      }) || variants.find(isSellable) || variants[0];
    }

    function possibleWith(position, value) {
      if (!variants.length) return true;
      const test = selectedOptions.slice();
      test[position - 1] = value;
      return variants.some((variant) => {
        return variant.options.every((opt, index) => test[index] == null || String(opt) === String(test[index]));
      });
    }

    function updateOptionStates() {
      optionButtons.forEach((button) => {
        const position = Number(button.dataset.rideOptionPosition || 1);
        const value = button.dataset.rideOptionValue || '';
        const active = String(selectedOptions[position - 1]) === String(value);
        button.classList.toggle('active', active);
        button.classList.toggle('on', active);
        const possible = possibleWith(position, value);
        button.classList.toggle('option-unavailable', !possible);
        button.disabled = !possible;
      });

      const padValue = selectedOptions.find((value) => /rot|grau/i.test(value)) || selectedOptions[0];
      if (padName && padValue) {
        padName.textContent = /grau/i.test(padValue) ? 'Grau — Zurückgelehnt' : 'Rot — Aufrecht & vorgebeugt';
        padName.style.color = '';
      }

      const sizeValue = selectedOptions.find((value) => /^(S|M|L|XL|2XL|3XL|4XL)$/i.test(value));
      if (sizeName) {
        if (sizeValue) {
          const sizeRanges = { S: '76–84 cm', M: '84–94 cm', L: '94–104 cm', XL: '104–114 cm', '2XL': '114–124 cm' };
          sizeName.textContent = `${sizeValue} · ${sizeRanges[sizeValue] || ''}`.trim();
          sizeName.style.color = '';
        } else {
          sizeName.textContent = '— bitte wählen';
        }
      }
    }

    function updateVariant(pushUrl = false) {
      const variant = currentVariant();
      if (!variant) return;

      if (idInput) idInput.value = variant.id;
      if (sku) sku.textContent = `SKU · ${variant.sku || root.dataset.productHandle || 'STR-RDS-01'}`;
      if (priceNow) priceNow.textContent = formatMoney(variant.price, currency);
      if (priceOld && saveTag) {
        if (variant.compare_at_price && Number(variant.compare_at_price) > Number(variant.price)) {
          priceOld.textContent = formatMoney(variant.compare_at_price, currency);
          priceOld.hidden = false;
          const saved = Number(variant.compare_at_price) - Number(variant.price);
          saveTag.textContent = `Sie sparen ${formatMoney(saved, currency)}`;
          saveTag.hidden = false;
        } else {
          priceOld.hidden = true;
          saveTag.hidden = true;
        }
      }

      const available = isSellable(variant);
      [cta, stickyCta].forEach((button) => {
        if (!button) return;
        button.disabled = !available;
        button.setAttribute('aria-disabled', available ? 'false' : 'true');
        if (button === cta) {
          const label = button.querySelector('span') || button;
          label.textContent = available ? 'In den Warenkorb' : 'Ausverkauft';
        } else if (button === stickyCta) {
          button.textContent = available ? 'In den Warenkorb →' : 'Ausverkauft';
        }
      });

      if (pushUrl && variant.id && window.history && window.location.search !== `?variant=${variant.id}`) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }

      updateOptionStates();
    }

    optionButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const position = Number(button.dataset.rideOptionPosition || 1);
        selectedOptions[position - 1] = button.dataset.rideOptionValue || '';
        updateVariant(true);
      });
    });

    const mainFrame = root.querySelector('.main-frame');
    const mainImg = root.querySelector('[data-ride-main-img]');
    const thumbs = [...root.querySelectorAll('[data-ride-thumb]')];
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        thumbs.forEach((item) => item.classList.remove('active'));
        thumb.classList.add('active');
        const src = thumb.dataset.src;
        const alt = thumb.dataset.alt || '';
        const fit = thumb.dataset.fit || 'cover';
        if (mainFrame) {
          mainFrame.dataset.rideFit = fit;
          mainFrame.style.aspectRatio = fit === 'contain' ? '1 / 1' : '';
        }
        if (mainImg && src) {
          mainImg.style.opacity = '0';
          window.setTimeout(() => {
            mainImg.src = src;
            mainImg.alt = alt;
            mainImg.style.opacity = '1';
          }, 120);
        }
      });
    });

    function moveGallery(dir) {
      if (!thumbs.length) return;
      const index = thumbs.findIndex((thumb) => thumb.classList.contains('active'));
      const next = (index + dir + thumbs.length) % thumbs.length;
      thumbs[next].click();
    }
    root.querySelector('[data-ride-gallery-prev]')?.addEventListener('click', () => moveGallery(-1));
    root.querySelector('[data-ride-gallery-next]')?.addEventListener('click', () => moveGallery(1));

    const deliveryDate = root.querySelector('[data-ride-delivery-date]');
    if (deliveryDate) deliveryDate.textContent = workingDeliveryDate();

    const countdown = root.querySelector('[data-ride-countdown]');
    if (countdown) {
      let target = Date.now() + (4 * 3600 + 23 * 60 + 41) * 1000;
      const tick = () => {
        let diff = Math.max(0, target - Date.now());
        const h = Math.floor(diff / 3600000); diff -= h * 3600000;
        const m = Math.floor(diff / 60000); diff -= m * 60000;
        const s = Math.floor(diff / 1000);
        countdown.querySelector('[data-h]').textContent = pad(h);
        countdown.querySelector('[data-m]').textContent = pad(m);
        countdown.querySelector('[data-s]').textContent = pad(s);
      };
      tick();
      window.setInterval(tick, 1000);
    }

    function flashStatus(text, ok = true) {
      if (!status) return;
      status.textContent = text;
      status.style.color = ok ? 'var(--ok)' : 'var(--alert)';
      status.classList.add('show');
      window.setTimeout(() => status.classList.remove('show'), 3000);
    }

    async function addToCart() {
      if (!form || !idInput || !idInput.value) return;
      const selectedSize = root.querySelector('[data-ride-option-kind="size"].active');
      if (!selectedSize && root.querySelector('[data-ride-option-kind="size"]')) {
        if (sizeName) {
          sizeName.textContent = '— bitte Größe wählen';
          sizeName.style.color = 'var(--alert)';
        }
        root.querySelector('[data-ride-sizes]')?.animate([
          { transform: 'translateX(0)' },
          { transform: 'translateX(-4px)' },
          { transform: 'translateX(4px)' },
          { transform: 'translateX(0)' }
        ], { duration: 250 });
        return;
      }

      const formData = new FormData(form);
      if (!formData.get('quantity')) formData.set('quantity', '1');
      [cta, stickyCta].forEach((button) => button?.setAttribute('aria-busy', 'true'));
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: formData
        });
        if (!response.ok) throw new Error(await response.text());
        flashStatus('Hinzugefügt. Warenkorb aktualisiert.');
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:open'));
      } catch (error) {
        flashStatus('Bitte prüfen Sie die Auswahl.', false);
        try { form.submit(); } catch (_) {}
      } finally {
        [cta, stickyCta].forEach((button) => button?.removeAttribute('aria-busy'));
      }
    }

    form?.addEventListener('submit', (event) => {
      event.preventDefault();
      addToCart();
    });
    cta?.addEventListener('click', (event) => {
      event.preventDefault();
      addToCart();
    });
    stickyCta?.addEventListener('click', (event) => {
      event.preventDefault();
      addToCart();
    });

    const sticky = root.querySelector('[data-ride-sticky]');
    const hero = root.querySelector('.hero');
    if (sticky && hero && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(([entry]) => {
        sticky.classList.toggle('show', !entry.isIntersecting);
      }, { rootMargin: '-80% 0px 0px 0px' });
      observer.observe(hero);
    }

    updateVariant(false);
  }

  function initAll() {
    document.querySelectorAll(SELECTOR).forEach(initRideShort);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
